import URL from '../url'
import Request from '../request'

export const getBadgesService = () => new Request(URL.API, URL.GET_BADGES).get()
